
import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import {
  Document,
  DocumentAttributes,
  DocumentRegistrationResult,
  IDocumentImageSource
} from "../../../../domain/document";
import { IContentSource } from "../../../../domain/drawing";
import { IHisInformationAccessible } from "../../../../domain/his";
import { ModelEditableMixin } from "../../../system/mixins";
import {
  IRestrictions,
} from "../../editor";
import { IDocumentEditMenuConfiguration, IToolTabDefinition } from "../../editor/contents";
import { ITabDefinition } from "../../editor/contents/tools";

@Component
export default class DocumentEditorBaseMixin extends Mixins(ModelEditableMixin) {
  editingSource: Document;

  @Prop({ default: false })
  isEmbedded: boolean;

  @Prop({ default: false })
  shouldRestrictDocumentNote: boolean;

  @Prop()
  restrictions: IRestrictions;

  @Prop()
  editMenuConfiguration: IDocumentEditMenuConfiguration;

  @Prop()
  initializeNewExtraDocument: (extraDocument: Document, document: Document) => Promise<void>;

  @Prop()
  getExtraDocument: (patientId: string, formatId: number) => Promise<Document>;

  @Prop()
  register: (source: Document, isTemporary: boolean, isPublish: boolean) => Promise<DocumentRegistrationResult>;

  @Prop()
  postRegistrationProcess: (id: number) => Promise<void>;

  @Prop()
  getReferenceFile: (fileId: number | string) => Promise<IContentSource>;

  @Prop()
  createImageSource: (imageText: string) => Promise<IDocumentImageSource>;

  @Prop()
  createPreviewCacheSource: (document: Document) => Promise<IContentSource>;

  @Emit()
  documentRegistered(id: number, destinationRoute: any, isTemporary?: boolean, archiveId?: number, isWindowClosing?: boolean): any {}

  @Prop()
  defaultToolTabName: string;

  @Prop()
  additionalToolTabs: IToolTabDefinition[];

  @Prop()
  additionalDocumentViewToolTabs: ITabDefinition[];

  @Prop({ default: false })
  hasAdditionalComments: boolean;

  @Prop()
  hisInformationAccessor: IHisInformationAccessible;
  
  data(): any {
    return {
      isDocumentInitialized: false,
    };
  }
  isDocumentInitialized: boolean;

  get isLoaded(): boolean {
    return (this.editingSource !== null);
  }

  get initializedDocument(): Document {
    return this.isDocumentInitialized
      ? this.editingSource
      : null;
  }

  get attributes(): DocumentAttributes {
    return this.readPropertyOrDefault(s => s.attributes, null);
  }

  set attributes(source: DocumentAttributes) {
    this.writeDocumentPropertyWhenValid(s => s.attributes = source);
  }

  writeDocumentPropertyWhenValid(writer: (source: Document) => void): void {
    this.writePropertyWhenValid(s => {
      writer(s);
      s.freezeItems();
    });
  }

  onDocumentInitialized(): void {
    this.initialized();
    this.isDocumentInitialized = true;
  }

  @Emit()
  ready(): void {}

  @Emit()
  initialized(): void {}
}
